import { Component, forwardRef, Host, Input, OnInit, Optional, SkipSelf } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PremiumPaymentType } from 'src/app/models/type/premium-payment.type.enum';
import { FormControlBase } from 'src/app/shared/inputs/form-control-base';

@Component({
  selector: 'app-input-radio-premium-payment',
  templateUrl: './input-radio-premium-payment.component.html',
  styleUrls: ['./input-radio-premium-payment.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputRadioPremiumPaymentComponent),
      multi: true
    }
  ]
})
export class InputRadioPremiumPaymentComponent extends FormControlBase<any> implements OnInit {

  @Input() isDisabled?: boolean;

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer
  ) { super(cc); }

  get insured(): string {
    return PremiumPaymentType.Insured.toString();
  }

  get anotherPerson(): string {
    return PremiumPaymentType.AnotherPerson.toString();
  }

  ngOnInit() {
    this.checkInitialControl();
  }

}
